import { render } from "./Styles.vue?vue&type=template&id=2612ee1c"
import script from "./Styles.vue?vue&type=script&lang=js"
export * from "./Styles.vue?vue&type=script&lang=js"
script.render = render

export default script